import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
} from '@mui/material';

export type Props = {
  open: boolean,
  version: string,
  onClose: () => void,
};

const ChangelogDialog: React.FC<Props> = ({ open, version, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ textAlign: 'center' }}>
      更新履歴
    </DialogTitle>
    <DialogContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="body2">{`${version}（最新）`}</Typography>
        <Typography variant="caption" color="text.secondary">- サインアウト関係の処理を見直しました</Typography>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body2">1.0.29</Typography>
        <Typography variant="caption" color="text.secondary">- 連絡帳画面でコメントの改行が正しく表示されない不具合を修正しました</Typography>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body2">1.0.28</Typography>
        <Typography variant="caption" color="text.secondary">- 連絡帳画面の前日の記録には*をつけるように修正</Typography>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body2">1.0.0</Typography>
        <Typography variant="caption" color="text.secondary">- 正式リリース</Typography>
      </Box>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center' }}>
      <Button onClick={onClose}>閉じる</Button>
    </DialogActions>
  </Dialog>
);

export default ChangelogDialog;
